<div id="section-updated" *ngIf="contextId && finishedLoading"
     class="object-update-log information-tabs-table">
  <table mat-table [dataSource]="logItems" *ngIf="logItems.length">

    <ng-container matColumnDef="updated_at" *ngIf="logItems.length">
      <th mat-header-cell *matHeaderCellDef translate="TRANS__FIELD__UPDATED_AT"></th>
      <td mat-cell *matCellDef="let element">{{element['updated_at']}} </td>
    </ng-container>
    <ng-container matColumnDef="updated_by_id" *ngIf="logItems.length">
      <th mat-header-cell *matHeaderCellDef translate="TRANS__FIELD__UPDATED_BY"></th>
      <td mat-cell *matCellDef="let element"> {{element['updated_by_id']}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div *ngIf="logItems.length === 0 && finishedLoading">
    <span translate="TRANS__OBJECT_UPDATE_LOG__NO_REGISTERED_CHANGES"></span>
  </div>
  <mat-spinner *ngIf="!finishedLoading" [diameter]="16" color="accent"></mat-spinner>
</div>
